@let file = messageFile();
@if (message(); as message) {
  @let formattedBody = message.content['formatted_body'];
  @let body = message.content['body'];
  <div class="message-row" [attr.data-testid]="testIds.completeFieldMessage">
    @if (['m.file', 'm.video', 'm.audio', 'm.image'].includes(file!.content['msgtype'] || '')) {
      <mat-icon svgIcon="{{ getFileIcon(file!.name, file!.size) }}" class="message-icon"></mat-icon>
    }

    <mat-card
      class="message-card"
      [attr.data-testid]="testIds.fieldMessage"
      (mouseenter)="toogleToolbarAndPin(message)"
      (mouseleave)="onMouseLeave($event)">
      @if (message.isPinned) {
        <div class="pin-icon">
          <mat-icon
            svgIcon="pin-icon-mini"
            class="small-pin"
            [attr.data-testid]="testIds.unpinMessageIcon"
            [matTooltip]="'Lösen'"
            (keydown)="pinnedMessageService.unpinMessage(message.eventId)"
            (click)="pinnedMessageService.unpinMessage(message.eventId)"></mat-icon>
        </div>
      } @else if (showPin) {
        <div class="pin-icon">
          <mat-icon
            svgIcon="pin-icon-mini"
            class="small-pin"
            [attr.data-testid]="testIds.pinMessageIcon"
            [matTooltip]="'Pin'"
            (keydown)="pinnedMessageService.pinMessage(message.eventId)"
            (click)="pinnedMessageService.pinMessage(message.eventId)">
          </mat-icon>
        </div>
      }
      <mat-card-header>
        <mat-card-subtitle [matTooltip]="message.senderId" class="sender">
          {{ accountService.isLoggedIn(message.senderId) ? 'Sie' : message.sender }}:
        </mat-card-subtitle>
      </mat-card-header>
      @if (message.inReplyTo) {
        <div
          class="reply-quote"
          (click)="scrollToMessage(message.inReplyTo.eventId)"
          (keydown.enter)="scrollToMessage(message.inReplyTo.eventId)"
          role="button"
          tabindex="0">
          <mat-card class="message-card" [ngClass]="message.inReplyTo.senderId === userId ? 'sendMsg' : 'receivedMsg'">
            <mat-card-header>
              <mat-card-subtitle class="sender">
                {{ message.inReplyTo.senderId === userId ? 'Sie' : message.inReplyTo.sender }}:
              </mat-card-subtitle>
            </mat-card-header>
            <mat-card-content class="msg-content">
              @let cleanedQuote = message.inReplyTo.content['formatted_body'] || message.inReplyTo.body | cleanReply;

              @if (cleanedQuote.includes('data-mx-spoiler')) {
                @for (chunk of cleanedQuote | spoilerChunks; track chunk) {
                  @if (chunk.isSpoiler) {
                    <app-spoiler [content]="chunk.content" [preview]="true"></app-spoiler>
                  } @else {
                    <span
                      [innerHTML]="chunk.content"
                      (click)="handleMention($event)"
                      (keydown)="$event.stopPropagation()"></span>
                  }
                }
              } @else {
                <span
                  [innerHTML]="cleanedQuote"
                  (click)="handleMention($event)"
                  (keydown)="$event.stopPropagation()"></span>
              }
            </mat-card-content>
          </mat-card>
        </div>
      }

      <mat-card-content data-testid="field_message_content" class="msg-content message-input">
        @switch (message.content['msgtype']) {
          @case (MsgType.Text) {
            @let rawBody = formattedBody || body;
            @let cleanedBody = message.inReplyTo ? (rawBody | cleanReply) : rawBody;

            @if (message.inReplyTo) {
              <span
                [innerHTML]="cleanedBody"
                (click)="handleMention($event)"
                appCustomLink
                (keydown)="$event.stopPropagation()"></span>
            } @else {
              @if (formattedBody) {
                @for (chunk of formattedBody | spoilerChunks; track chunk) {
                  @if (chunk.isSpoiler) {
                    <app-spoiler [content]="chunk.content" [preview]="false"></app-spoiler>
                  } @else {
                    <span
                      [innerHTML]="chunk.content"
                      appCustomLink
                      (click)="handleMention($event)"
                      (keydown)="$event.stopPropagation()"></span>
                  }
                }
              } @else {
                <span
                  [innerHTML]="body"
                  appCustomLink
                  (click)="handleMention($event)"
                  (keydown)="$event.stopPropagation()"></span>
              }
            }
          }
          @case ('m.bad.encrypted') {
            <span>
              <strong>Die Nachricht kann derzeit nicht entschlüsselt werden.</strong> Möglicherweise wurde der
              erforderliche Schlüssel noch nicht hinterlegt. Bitte prüfen Sie die Schlüsselverwaltung unter
              <strong>Einstellungen</strong> und ergänzen Sie den Schlüssel gegebenenfalls.
            </span>
          }
          @case (MsgType.Image) {
            <div class="image-text-wrapper">
              @if (!fileUrl) {
                @if (message.content['info']['thumbnail_info']) {
                  <div class="file-border image">
                    <button
                      [attr.data-testid]="testIds.buttonImagecontainer"
                      class="image-button"
                      (click)="this.downloadFile(file!)">
                      <canvas
                        #canvas
                        [width]="message.content['info']['thumbnail_info']?.['w']"
                        [height]="message.content['info']['thumbnail_info']?.['h']"
                        class="message-image">
                      </canvas>
                    </button>
                    <div class="file-actions">
                      <span class="name-color clamp-text file-name-button">{{ file?.name }}</span>
                      <span class="name-color">({{ formatFileSize(file?.size!) }})</span>
                      <mat-icon
                        svgIcon="information"
                        class="file-action-icon"
                        [matTooltip]="loadMetadataText"
                        (mouseenter)="showMetadata(messageFile()!)"></mat-icon>
                    </div>
                  </div>
                } @else {
                  <div class="file-wrapper">
                    <button
                      class="file-button file-border"
                      [attr.data-testid]="testIds.linkDownloadfile"
                      mat-button
                      (click)="downloadFile(file!)"
                      (keydown)="onKeyDown($event, file!)"
                      [class.disabled]="file?.size === 0 || currentFileStatus.status !== 'active'"
                      [class.file-inactive]="currentFileStatus.status !== 'active'"
                      tabindex="0">
                      <div class="file-actions">
                        <mat-icon svgIcon="image"></mat-icon>
                        <span class="clamp-text file-name-button">{{ file?.name }}</span>
                        <span>({{ formatFileSize(file?.size!) }})</span>
                        <mat-icon
                          (mouseenter)="showMetadata(messageFile()!)"
                          [matTooltip]="loadMetadataText"
                          class="file-action-icon"
                          svgIcon="information"></mat-icon>
                      </div>
                    </button>
                  </div>
                }
              } @else {
                <div class="file-border image">
                  <img
                    [src]="fileUrl"
                    [width]="message.content['info']['w']"
                    [height]="message.content['info']['h']"
                    class="message-image"
                    (load)="onImageLoad(file!)"
                    (error)="handleError(file!, blurhashImage)"
                    alt="{{ message.body }}"
                    loading="lazy" />
                  <div class="file-actions">
                    <span class="name-color clamp-text file-name-button">{{ file?.name }}</span>
                    <span class="name-color">({{ formatFileSize(file?.size!) }})</span>
                    <mat-icon
                      svgIcon="information"
                      class="file-action-icon"
                      [matTooltip]="loadMetadataText"
                      (mouseenter)="showMetadata(messageFile()!)"></mat-icon>
                  </div>
                </div>
              }

              <div class="caption" style="margin-top: 8px">
                @if (formattedBody) {
                  <div
                    [innerHTML]="formattedBody"
                    (click)="handleMention($event)"
                    class="caption-content"
                    (keydown)="$event.stopPropagation()"></div>
                } @else if (message.content['org.matrix.msc1767.text']) {
                  <div
                    [innerHTML]="message.content['org.matrix.msc1767.text']"
                    (click)="handleMention($event)"
                    appCustomLink
                    (keydown)="$event.stopPropagation()"></div>
                } @else if (body && body !== message.content['filename']) {
                  <div
                    [innerHTML]="body"
                    (click)="handleMention($event)"
                    appCustomLink
                    (keydown)="$event.stopPropagation()"></div>
                }
              </div>
            </div>
          }
          @case (MsgType.Location) {
            @let long = message.latAndLong?.long!;
            @let lat = message.latAndLong?.lat!;
            <a [href]="'https://www.google.com/maps/search/?api=1&query=' + lat + ',' + long" target="_blank">
              {{ message.body }}
            </a>
          }
          @default {
            @if (Object.keys(message['content']).length !== 0) {
              <div class="file-wrapper">
                <button
                  class="file-button file-border"
                  [attr.data-testid]="testIds.linkDownloadfile"
                  mat-button
                  (click)="downloadFile(file!)"
                  (keydown)="onKeyDown($event, file!)"
                  [class.disabled]="file?.size === 0 || currentFileStatus.status !== 'active'"
                  [class.file-inactive]="currentFileStatus.status !== 'active'"
                  tabindex="0">
                  <div class="file-actions">
                    @let fileIcon = getFileTypeIcon(file?.name);
                    @if (fileIcon) {
                      <mat-icon svgIcon="{{ fileIcon }}"></mat-icon>
                    }
                    <span class="clamp-text file-name-button">{{ file?.name }}</span>
                    <span>({{ formatFileSize(file?.size!) }})</span>
                    <mat-icon
                      svgIcon="information"
                      class="file-action-icon"
                      [matTooltip]="loadMetadataText"
                      (mouseenter)="showMetadata(messageFile()!)"></mat-icon>
                  </div>
                </button>
                <div class="caption" style="margin-top: 8px">
                  @if (formattedBody) {
                    <span
                      [innerHTML]="formattedBody"
                      (click)="handleMention($event)"
                      (keydown)="$event.stopPropagation()"
                      appCustomLink
                      class="caption-content"></span>
                  } @else if (message.content['org.matrix.msc1767.text']) {
                    <span
                      [innerHTML]="message.content['org.matrix.msc1767.text']"
                      (click)="handleMention($event)"
                      (keydown)="$event.stopPropagation()"
                      appCustomLink>
                    </span>
                  } @else {
                    <span
                      [innerHTML]="message.content['body']"
                      (click)="handleMention($event)"
                      (keydown)="$event.stopPropagation()"
                      appCustomLink>
                    </span>
                  }
                </div>
              </div>
            } @else {
              <span [innerHTML]="message['formattedBody']" appCustomLink></span>
            }
          }
        }
      </mat-card-content>
    </mat-card>

    <div class="message-timestamp">
      @if (!isSentByMe(message)) {
        <app-user-icon
          [userId]="message.senderId"
          [presenceStatus]="presenceService.getPresence(message.senderId)"></app-user-icon>
      }
      <div class="status-icon">
        @if (isSentByMe(message) && message.displayStatus) {
          @switch (message.displayStatus) {
            @case (EventStatus.SENT) {
              @if (message.isReadByAll$ | async) {
                <mat-icon
                  class="message-icon"
                  [svgIcon]="'message-seen'"
                  [matTooltip]="'Von allen gelesen'"
                  [attr.data-testid]="testIds.fieldMessageSeen">
                </mat-icon>
              } @else {
                <mat-icon
                  class="message-icon"
                  [svgIcon]="'send-success'"
                  [attr.data-testid]="testIds.fieldMessageSent"></mat-icon>
              }
            }
            @case (EventStatus.NOT_SENT) {
              <mat-icon
                class="message-icon"
                [svgIcon]="'send-error'"
                [attr.data-testid]="testIds.fieldMessageResend"
                onKeyDown="sendAgain(message)"
                (click)="sendAgain(message)">
              </mat-icon>
            }
            @default {
              <mat-icon class="message-icon-schedule message-icon"> schedule</mat-icon>
            }
          }
        }

        @if (message.isEdited && message.content['msgtype'] !== 'm.bad.encrypted') {
          <div class="edited-container">
            <!-- A_26249 - Historie von Event Replacements -->
            <button
              class="edit-btn"
              mat-button
              (keyup.enter)="openHistory(history, message.eventId)"
              [attr.data-testid]="testIds.fieldEdit"
              (click)="openHistory(history, message.eventId)">
              (bearbeitet)
            </button>
          </div>
        }
      </div>

      @if (message.date) {
        <div [matTooltip]="message.date | date: 'full'">
          @if (DateUtils.isToday(message.date)) {
            Heute {{ message.date | date: 'shortTime' }}
          } @else {
            {{ message.date | date: 'short' }}
          }
        </div>
      }
      @if (message.reactionsArray && message.reactionsArray.length > 0) {
        <div class="reaction-container" [class.own-reaction-container]="isSentByMe(message)">
          @for (reaction of message.reactionsArray; track reaction.emoji) {
            <button
              mat-mini-fab
              [attr.data-testid]="testIds.buttonReaction"
              class="reaction-button"
              [disabled]="roomHelperService.getRoomMembership(room().roomId) === KnownMembership.Leave"
              [class]="{
                'own-reaction': isOwnReaction(reaction),
                multiple: message.reactionsArray.length > 1 && isOwnReaction(reaction)
              }"
              (click)="checkReaction(message.reactionsArray, reaction.emoji, reaction.events, message.eventId)">
              <span class="reaction-inner">
                <span class="reaction-content">
                  <ngx-emoji [emoji]="getIdFromUnicode(reaction.emoji)" data-testid="reaction_emoji"></ngx-emoji
                ></span>
                @if (reaction.events.length > 1) {
                  <span class="reaction-count" data-testid="reaction_counter">
                    {{ reaction.events.length }}
                  </span>
                }
              </span>
            </button>
          }
        </div>
      }
    </div>

    <ng-template #history>
      <h2 matDialogTitle>Bearbeitungshistorie</h2>
      <mat-dialog-content class="history-content">
        @for (historyEntry of historyEntries; track $index) {
          <mat-dialog-content [attr.data-testid]="'dialog_content_' + $index">
            <p [attr.data-testid]="testIds.editHistoryDate">
              {{ historyEntry.timestamp | date: 'dd.MM.yyyy HH:mm' }}
            </p>
            <div class="history-render" [innerHTML]="getSanatizedHighlighter(historyEntry)"></div>
          </mat-dialog-content>
        }
      </mat-dialog-content>
      <mat-dialog-actions align="end">
        <app-button (clicked)="onCancel()" [dataTestId]="'button_cancel'" text="Abbrechen"></app-button>
      </mat-dialog-actions>
    </ng-template>
  </div>
}
